import { ReactNode } from 'react';

import type { FeeTone } from '@/helpers/paymentDeviceFees';

/** The status pills of the payment-devices screens: a tinted capsule with a dot of the same family. */
export type Tone = FeeTone;

const toneClasses: Record<Tone, { pill: string; dot: string }> = {
  neutral: { pill: 'bg-(--surface-grey-low) text-(--border-dark)', dot: 'bg-(--border-strong)' },
  success: { pill: 'bg-(--surface-tertiary-low) text-(--font-tertiary)', dot: 'bg-(--font-tertiary)' },
  danger: { pill: 'bg-[#fdecec] text-[#a12626]', dot: 'bg-[#c0392b]' },
  warning: { pill: 'bg-[#fff4e5] text-[#8a4b00]', dot: 'bg-[#e08a1e]' },
  info: { pill: 'bg-(--surface-secondary-low) text-(--font-body-5)', dot: 'bg-(--surface-secondary)' },
};

export const Pill = ({ tone, children, dot = true, small = false }: { tone: Tone; children: ReactNode; dot?: boolean; small?: boolean }) => (
  <span className={`inline-flex items-center gap-1.5 rounded-full whitespace-nowrap font-semibold ${small ? 'h-6 px-2.5 text-xs' : 'h-7 px-3 text-[13px]'} ${toneClasses[tone].pill}`}>
    {dot && <span className={`w-2 h-2 rounded-full ${toneClasses[tone].dot}`} />}
    {children}
  </span>
);
